import React from "react"

//
// class ClockCountAgingDeath extends React.Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       time: 0,
//       start: 0
//     }
//     this.startTimer = this.startTimer.bind(this)
//
//   }
//
//   startTimer() {
//     this.setState({
//       time: this.state.time,
//       start: Date.now() - this.state.time
//     })
//     this.timer = setInterval(() => this.setState({
//       time: Date.now() - this.state.start
//     }), 1)
//     console.log("start")
//   }
//
//   render() {return(
//     <Statistic title="Time" value={this.state.time}/>
//   )
//   }
// }
//
//

// const React = require('react')

class ClockCountAgingDeath extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      time: 0,
      start: 0,
      isOn: false
    }
    this.startTimer = this.startTimer.bind(this)
    this.stopTimer = this.stopTimer.bind(this)
    this.resetTimer = this.resetTimer.bind(this)
  }

  componentDidMount() {
this.startTimer()
  }

  startTimer() {
    this.setState({
      time: this.state.time,
      start: Date.now() - this.state.time,
      isOn: true
    })
    this.timer = setInterval(() => this.setState({
      time: Date.now() - this.state.start
    }), 1);
  }

  stopTimer() {
    this.setState({isOn: false})
    clearInterval(this.timer)
  }

  resetTimer() {
    this.setState({time: 0})
  }

  render() {
    return (
      <div>
        <h3>{Math.round(this.state.time*1.4 /1000)} death{this.state.time*1.4 > 1401 ? (<>s</>):(<></>)} since you started reading.</h3>

      </div>
    )
  }
}

export default ClockCountAgingDeath

